var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refund-history"},[_c('div',{staticClass:"page"},[_c('div',{staticClass:"page-content"},[_c('crumbsVue',{attrs:{"navs":_vm.navs}}),_vm._l((_vm.dataList),function(item,index){return _c('refundHistory',{key:index,staticClass:"mb20",attrs:{"item":item}})})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }